import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const LINKS = [
  { href: "#como-funciona", label: "Cómo funciona" },
  { href: "#caracteristicas", label: "Características" },
  { href: "#contacto", label: "Contacto" },
];

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="landing-nav"
      className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color] duration-300 ${
        scrolled
          ? "border-white/10 bg-[#080D1A]/80 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
        <a href="#top" data-testid="landing-logo" className="group flex items-center gap-3">
          <img
            src="https://customer-assets-lxgj4vgw.emergentagent.net/job_myfire-battles/artifacts/41aefba8a1ad4cfb_pinza_logo_1.webp"
            alt="La Pinza"
            className="h-9 w-9 object-contain"
          />
          <span className="font-heading text-xl font-black tracking-tighter text-white">
            LA PINZA
          </span>
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="font-ui text-[11px] font-bold uppercase tracking-[0.22em] text-[#94A3B8] transition-colors duration-200 hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="https://instagram.com/lapinza.app"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-instagram"
            aria-label="Instagram de La Pinza"
            className="flex h-10 w-10 items-center justify-center border border-white/10 text-[#94A3B8] transition-colors duration-200 hover:border-[#FF5500] hover:text-[#FF5500]"
          >
            <Instagram className="h-4 w-4" />
          </a>
          <Link
            to="/eventos"
            data-testid="nav-ver-eventos"
            className="hidden bg-[#FF5500] px-5 py-2.5 font-ui text-[11px] font-bold uppercase tracking-[0.2em] text-white transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_24px_-6px_rgba(255,85,0,0.6)] sm:inline-block"
          >
            Eventos en Vivo
          </Link>
        </div>
      </div>
    </header>
  );
}
